module.exports = __webpack_public_path__ + "static/img/banner-cursos-interior-500x750.3830f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-cursos/banner-cursos-interior-500x750.jpg
// module id = 937d
// module chunks = 47